import { Container, Row, Col, Carousel } from 'react-bootstrap'
import { isMobile } from 'react-device-detect'
import ContactoFooter from '../contactoFooter'
import styles from './Eventos.module.css'
import './Eventos.css'

const importAll = (requireContext) => requireContext.keys().map(requireContext)
const images = importAll(
  require.context('../../../public/Carrousell', false, /\.(jpg|jpeg|png)$/)
)

export default function Eventos() {
  return (
    <>
      <section className="eventos-section">
        <Container fluid className="text-center">
          <Row className="justify-content-center align-items-center">
            <Col
              xs={12}
              md={6}
              className="d-flex flex-column align-items-center mb-3 mb-md-0"
            >
              <img
                src="/logoVenue.webp"
                alt="logo en Areia Venue"
                className="eventos-logo"
              />
              <h1 className="tituloVenue">
                EVENTOS <span className="distintos">DISTINTOS</span>
              </h1>
              <h2 className="eventos-descripcion">
                Trabajamos con dedicación en cada detalle
                <br />
                para que tu evento sea único.
              </h2>
              <button
                className={`eventos-boton ${styles.margin15}`}
                onClick={() =>
                  window.open('https://wa.me/+5491134022431', '_blank')
                }
              >
                más información
              </button>
            </Col>
            <Col xs={12} md={6} className="p-0">
              <div className="eventos-imagen-container">
                <img
                  src="/1.png"
                  alt="Evento en Areia Venue"
                  className="eventos-imagen"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="momentos-section">
        <Container fluid className="p-5">
          <Row className="justify-content-start">
            <Col xs={12} md={6}>
              <h1 className="tituloVenue2">
                Coleccioná <br /> momentos, no cosas.
              </h1>
            </Col>
          </Row>
          <Row className="justify-content-end mt-4">
            <Col xs={12} md={6}>
              <p className="eventos-descripcion">
                AREIA es una empresa con más de 10 <br /> años de experiencia en
                la organización de eventos <br /> tanto sociales como
                corporativos.
              </p>
              <button
                className={`eventos-boton ${styles.margin10}`}
                onClick={() =>
                  window.open('https://wa.me/+5491134022431', '_blank')
                }
              >
                Pedir presupuesto
              </button>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="seccion-blanco">
        <Container fluid className="p-5 text-center">
          <Row>
            <h2 className="carrousel-descripcion">
              Un espacio en medio de la naturaleza{' '}
              <strong className="carrousel-descripcion">
                a solo 35 km de CABA
              </strong>{' '}
              que te ofrece todo lo que necesitás: propuesta gastronómica,
              barra, ambientación, planner de AREIA a cargo del evento ¡y mucho
              más!
            </h2>
          </Row>
        </Container>
      </section>
      <section className={`carousel-section ${styles.carouselSection}`}>
        <Container fluid className="p-0">
          <Row className="m-0">
            <Col className="p-0">
              <Carousel
                className={`carousel-item-height ${styles.carouselStyle}`}
              >
                {images.map((image, index) => (
                  <Carousel.Item key={image} className="carousel-item-height">
                    <img
                      className={`d-block w-100 ${styles.carouselImg}`}
                      src={image}
                      alt={`Slide ${index + 1}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="seccion-ofrecemos">
        <div className="ofrecemos-container">
          <div className="ofrecemos-imagen-col">
            <img
              src="/evento1.webp"
              alt="Qué te ofrecemos en Areia Venue"
              className="ofrecemos-imagen"
            />
          </div>
          <div className="ofrecemos-info-col">
            <div className="ofrecemos-header">
              <h2 className="ofrecemos-titulo">Qué te ofrecemos</h2>
            </div>
            <div className="ofrecemos-lista">
              {[
                'Estacionamiento privado +500 autos',
                'Seguridad privada',
                'Catering & barra',
                'DJ & técnica e iluminación',
                'Actividades deportivas',
                'Event Planner y más!',
              ].map((feature, index) => (
                <div
                  className={`ofrecemos-item ofrecemos-item-${index + 1}`}
                  key={feature}
                >
                  <div className="ofrecemos-icon-wrapper">
                    <img
                      src={`/sinFondo/${index + 1}.png`}
                      className="ofrecemos-icon"
                      alt={feature}
                    />
                  </div>
                  <h4 className="ofrecemos-text">{feature}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {!isMobile && (
        <section className="seccion-blanco">
          <Container fluid className={styles.padding6}>
            <Row className="w-100">
              <Col xs={12} md={4}>
                <img
                  src="/eventos1.jpg"
                  alt="Evento en Areia Venue"
                  className="eventos-imagen borde"
                />
              </Col>
              <Col xs={12} md={4}>
                <img
                  src="/eventos2.jpg "
                  alt="Evento en Areia Venue"
                  className="eventos-imagen borde"
                />
              </Col>
              <Col xs={12} md={4}>
                <img
                  src="/eventos3.jpg"
                  alt="Evento en Areia Venue"
                  className="eventos-imagen borde"
                />
              </Col>
            </Row>
          </Container>
        </section>
      )}
      <section className="seccion-blanco">
        <Container fluid className="text-center">
          <Row>
            <Col xs={12} md={5} className={styles.corporativoCol}>
              <h1 className="tituloVenue2">Corporativo</h1>
              <img
                src="/2.png"
                alt="Evento en Areia Venue"
                className={styles.corporativoImg}
              />
              <Row className="text-start p-4">
                <h2 className="eventos-descripcion bold">TEAM BUILDING</h2>
                <p className={styles.corporativoText}>
                  Actividades divertidas y distendidas para tu empresa. El
                  objetivo es fomentar el trabajo en equipo y mejorar las
                  relaciones interpersonales.
                </p>
              </Row>
            </Col>
            <Col xs={12} md={7} className="text-start">
              <Row className={styles.actividadesCol}>
                <Col>
                  <img
                    src="/3.png"
                    alt="Evento en Areia Venue"
                    className={styles.actividadesImg}
                  />
                </Col>
                <Col>
                  <h2 className="eventos-descripcion bold">ACTIVIDADES</h2>
                  <p className={styles.actividadesText}>
                    Actividades deportivas coordinadas por miembros de nuestro
                    staff + distintas actividades recreativas disponibles
                    durante todo el evento.
                  </p>
                </Col>
              </Row>
              <Row className={styles.actividadesCol}>
                <Col>
                  <img
                    src="/4.png"
                    alt="Evento en Areia Venue"
                    className={styles.actividadesImg}
                  />
                </Col>
                <Col>
                  <h2 className="eventos-descripcion bold">CATERING & BARRA</h2>
                  <p className={styles.actividadesText}>
                    Nuestra propuesta incluye catering a lo largo de todo el
                    evento, y un after party opcional.
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="seccion-blanco">
        <Container fluid className={styles.padding10}>
          <Row>
            <h2 className={`sociales-title ${styles.socialesTitle}`}>
              Sociales
            </h2>
          </Row>
          <Row>
            <Col xs={12} md={6} className={styles.socialesCol}>
              <img
                src="/boda.jpg"
                alt="Evento en Areia Venue"
                className={styles.socialesCardImg}
              />
              <Row className={styles.casamientosRow}>
                <h2 className="eventos-descripcion bold">CASAMIENTOS</h2>
                <p>
                  Te acompañamos en el camino a este día tan especial con una
                  ejecutiva de AREIA a cargo de todo el evento para que ustedes
                  solo se ocupen de DISFRUTAR!
                </p>
              </Row>
            </Col>
            <Col xs={12} md={6} className={styles.socialesCol}>
              <img
                src="/DSC02042.jpg"
                alt="Evento en Areia Venue"
                className={styles.socialesCardImg}
              />
              <Row className={styles.cumpleRow}>
                <h2 className="eventos-descripcion bold">
                  CUMPLEAÑOS & FIESTAS
                </h2>
                <p>
                  Noches únicas con una propuesta increíble de catering, barra y
                  DJ -y más- para que disfrutes con tus invitados.
                </p>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Container
          fluid
          className={`text-center ${styles.experienciaContainer}`}
          style={{
            backgroundImage: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
            url(./DSC02017.jpg)
          `,
          }}
        >
          <p className={`${styles.experienciaText} tituloVenue3`}>
            Más de 5 hectáreas de espacio verde, ideales para desconectarse{' '}
            <br /> de la rutina y vivir una experiencia única.
            <br /> * <br /> La versatilidad de nuestras instalaciones permite
            que nos <br /> podamos adaptar perfectamente al tamaño del evento a
            realizar.
          </p>
        </Container>
      </section>
      <footer className={styles.footerWrapper}>
        <Container className={`text-center ${styles.footerContainer}`}>
          <Row className="h-100 justify-content-center align-items-center mt-5">
            <Col className="d-flex flex-column align-items-center gap-3">
              <h2 className="bold grande">
                AREIA SIEMPRE <br /> ESTUVO CERCA.
              </h2>
              <p className={styles.footerText}>
                A 35km de Capital Federal con fácil y rápido acceso en una zona{' '}
                <br />
                segura rodeada de barrios cerrados.
              </p>
              <button className="eventos-boton">VER MAPA</button>
            </Col>
          </Row>
        </Container>
      </footer>
      <ContactoFooter />
      <div className={styles.copyright}>
        Copyright 2024 AREIA©️ - Ementa SRL - Todos los derechos reservados
      </div>
    </>
  )
}
